import http from '@/plugins/axios';

export async function get_languages() {
    const response = await http.get(`languages`);
    return response.data.items;
}